import { render, staticRenderFns } from "./EditSettings.vue?vue&type=template&id=4db82b01"
import script from "./EditSettings.vue?vue&type=script&lang=js"
export * from "./EditSettings.vue?vue&type=script&lang=js"
import style0 from "./EditSettings.vue?vue&type=style&index=0&id=4db82b01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports